import React from 'react'
import { Badge } from '../../Badge'
import formStyles from '../../../styles/forms.module.scss'

export interface NotificationBannerMetadata {
  body?: string
}

interface NotificationBannerEditorProps {
  metadata: NotificationBannerMetadata
  onChange: (metadata: NotificationBannerMetadata) => void
}

// A notification banner is a skinny full-width alert strip (match delays,
// programming changes). Its whole payload is one markdown body, restricted to
// inline markdown — emphasis and links, no headings/lists/raw HTML — because
// clients render it with an inline parser inside a one-line strip. That's why
// this is a plain textarea and not the block-level MarkdownEditor editorial
// uses. Spec: docs/html/tennischannel/widgets/notification-banner.html
const NotificationBannerEditor: React.FC<NotificationBannerEditorProps> = ({ metadata, onChange }) => {
  return (
    <div className={formStyles.fieldGroup}>
      <label>Notice <Badge variant="secondary" size="small">Public</Badge></label>
      <textarea
        value={metadata.body || ''}
        onChange={(e) => onChange({ ...metadata, body: e.target.value })}
        placeholder="Roland-Garros semifinals are delayed ~90 min by rain — [see the schedule](/scores)."
        rows={3}
        aria-label="Notification banner notice"
      />
      <p className={formStyles.hint}>
        Inline markdown only: **bold**, *italic*, and [links](/path). Headings, lists, and HTML
        won’t render — the notice appears as a single alert strip.
      </p>
    </div>
  )
}

export default NotificationBannerEditor
